import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import widthMixin from 'styles/utils/widthMixin';

const flexBox = (props) => {
  return css`
    ${widthMixin} min-height: 34px;
  `;
};

const fixedWidth = (props) => {
  let btnAddon = props.btnAddon;
  return css`
    display: inline-block;
    position: relative;
    vertical-align: middle;
    ${(btnAddon) => props.styles || (btnAddon ? null : 'width: 30%; min-height: 34px')};
  `;
};

export const TriggerBlock = styled.div`
  ${(props) => (props.flexBox ? flexBox() : fixedWidth(props))};
`;

TriggerBlock.propTypes = {
  btnAddon: PropTypes.bool,
  flexBox: PropTypes.bool,
  cols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

TriggerBlock.defaultProps = {
  btnAddon: false,
  flexBox: true,
  cols: 1 / 4,
};

export default class TriggerPopover extends Component {
  constructor(props) {
    super();
    this.state = {
      displayPopover: props.displayPopover,
    };
    this.triggerShow = this.triggerShow.bind(this);
    this.triggerHide = this.triggerHide.bind(this);
    this.setDisplay = this.setDisplay.bind(this);
    this.clearDelayTimer = this.clearDelayTimer.bind(this);
  }

  componentWillUnmount() {
    this.clearDelayTimer();
  }

  triggerShow() {
    this.setDisplay(true);
  }

  triggerHide() {
    this.setDisplay(false);
  }

  setDisplay(displayPopover) {
    this.clearDelayTimer();
    if (displayPopover === this.state.displayPopover) return;
    const { delayShow, delayHide } = this.props;
    const delay = displayPopover ? delayShow : delayHide;
    if (delay) {
      this.delayTimer = setTimeout(() => {
        this.setState({ displayPopover });
      }, delay);
    } else {
      this.setState({ displayPopover });
    }
  }

  clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  }

  render() {
    const { displayPopover } = this.state;

    let children = [];
    const childCount = React.Children.count(this.props.children);
    React.Children.forEach(this.props.children, (child, i) => {
      if (child) {
        const key = child.key || `key-${i}`;
        let props = {};
        props.key = key;
        props.onMouseOver = this.triggerShow;
        props.onMouseOut = this.triggerHide;
        let newChild = React.cloneElement(child, props);
        if (childCount > 1) {
          children.push(newChild);
        } else {
          children = newChild;
        }
      }
    });

    const { flexBox, cols, styles } = this.props;
    return (
      <TriggerBlock cols={cols} flexBox={flexBox} styles={styles}>
        {children}
        {displayPopover && this.props.popover}
      </TriggerBlock>
    );
  }
}

TriggerPopover.defaultProps = {
  delayHide: 100,
  delayShow: 450,
  displayPopover: false,
  popover: null,
  flexBox: true,
  cols: 1 / 4,
};
